import { Box, LinearProgress } from "@mui/material";
import styled from "styled-components";

const Progress = styled(LinearProgress)`
  margin-top: ${({ theme }) => theme.spacing(10)};
`;

export const AuthRedirectProgress = () => (
  <Box width="100%">
    <Progress />
  </Box>
);
